<script setup>
import { useI18n } from "vue-i18n";

const props = defineProps({
    data: Object,
});

const { locale } = useI18n();
</script>

<template>
    <div v-if="data">
        <h5 class="ms-3 me-6">
            {{ data[locale.slice(0, 2)]?.title }}
        </h5>
    </div>
</template>
